import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { useFetchSurveysQuery } from "./surveysApi";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { EmptyState } from "@/components";
import Frame from "@/components/Frame";
import ROUTES from "@/constants/routes";
import { MoveRight } from "lucide-react";

const SurveyPage = () => {
    const { organizationId } = useParams<{ organizationId: string }>();
    const surveys = useFetchSurveysQuery(organizationId || skipToken);
    console.log("🚀 ~ surveys:", surveys);

    return (
        <Stack spacing={2}>
            <Typography variant="h2">
                Encuestas
            </Typography>
            {surveys.isLoading ? (
                <Stack flex={1} alignItems="center" py={5}>
                    <CircularProgress/>
                </Stack>
            ) : !surveys.data ? (
                <EmptyState/>
            ) : (
                <Stack spacing={2}>
                    {surveys.data.map((survey) => (
                        <Frame key={survey.id}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Typography variant="h3">{survey.title}</Typography>
                                <Button
                                    component={Link}
                                    to={ROUTES.organizations.surveys.details
                                        .replace(':organizationId', organizationId ?? '')
                                        .replace(':surveyId', survey.id ?? '')
                                    }
                                    endIcon={<MoveRight />}
                                >Ver Mas</Button>
                            </Stack>
                        </Frame>
                    ))}
                </Stack>
            )}
        </Stack>
    );
}

export default SurveyPage;
